export enum StepRequired {
    Off = 'off',
    Warn = 'warn',
    Error = 'error'
}
